module.exports = __webpack_public_path__ + "img/Asset 151.697c2bae.svg";